import React from "react";
import { Link } from "react-router-dom";

import "./_Header.scss";
import { FormattedMessage } from "react-intl";

const QuizHeader = props => {
  return (
    // is-fixed-top
    <div className="quiz-header">
      <div className="quiz-header-wrap">
        <div className="title">{props.title}</div>
        <span onClick={props.onBack} className="back-btn">
          <FormattedMessage id="hometraining.quiz-exit" />
        </span>
      </div>
    </div>
  );
};

export default QuizHeader;
